Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "OverlappingCard830285001",
  {"root":"OverlappingCard830285001--root","infoContainer":"OverlappingCard830285001--infoContainer","mediaContainer":"OverlappingCard830285001--mediaContainer","DefaultInfoCardBG":"color-1","DefaultMediaCardBG":"color-5","DefaultBorderColor":"color-5","DefaultBorderWidth":"1","MainBorderWidth":"--overridable","MainBorderColor":"--overridable","MainInfoColor":"--overridable","MainMediaColor":"--overridable","borderWidth":"\"unit(fallback(zeroAsTrue(--overridable), 1), px)\"","borderColor":"\"color(fallback(--overridable, color-5))\"","infoBGColor":"\"color(fallback(--overridable, color-1))\"","mediaBGColor":"\"color(fallback(--overridable, opacity(color(color-5), 0.2)))\"","infoPadding":"60px","negativeInfoPadding":"-60px","MinWidth":"700px"},
  "",
  3,
  "OverlappingCard830285001"
);

